"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoizable = exports.createChariotCacheHashFromObject = exports.createHashFromObject = void 0;
var ApiChariotResource_1 = require("../resources/api/ApiChariotResource");
var ChariotResource_1 = require("../resources/models/ChariotResource");
var ChariotResourceFactory_1 = require("../resources/factories/ChariotResourceFactory");
var Errors_1 = require("./Errors");
var ResourceCache_1 = require("./ResourceCache");
var toBase64 = typeof btoa !== "undefined" ? btoa : (function (s) { return Buffer.from(s).toString("base64"); });
var createHashFromObject = function (object) { return toBase64(JSON.stringify(object)); };
exports.createHashFromObject = createHashFromObject;
var createChariotCacheHashFromObject = function (chariot, object) {
    var cacheKey = __assign({ domain: chariot.auth.getOptions().domain, client: chariot.getClient()._ }, object);
    return (0, exports.createHashFromObject)(cacheKey);
};
exports.createChariotCacheHashFromObject = createChariotCacheHashFromObject;
var memoizeMethod = function (key, retrieve, method, cache, logger) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (cache.has(method, key)) {
                    logger.debug("Using cached ".concat(method, " response"));
                    return [2 /*return*/, cache.get(method, key)];
                }
                logger.debug("Creating new cached ".concat(method, " response"));
                return [4 /*yield*/, retrieve()];
            case 1:
                response = _a.sent();
                cache.set(method, key, response);
                return [2 /*return*/, cache.get(method, key)];
        }
    });
}); };
var memoizable = function (target, methodKey, descriptor) {
    switch (methodKey) {
        case "list": {
            var listFn_1 = descriptor.value;
            descriptor.value = function (options) {
                return __awaiter(this, void 0, void 0, function () {
                    var graphOptions, cacheKey, graphOptions, restOptions, retrieveData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(this instanceof ChariotResourceFactory_1.GraphEnabledChariotResourceFactory)) return [3 /*break*/, 3];
                                listFn_1 = listFn_1;
                                options = options;
                                graphOptions = options;
                                if (!(graphOptions === null || graphOptions === void 0 ? void 0 : graphOptions.selectionSet)) return [3 /*break*/, 2];
                                return [4 /*yield*/, listFn_1.call(this, options)];
                            case 1: return [2 /*return*/, _a.sent()];
                            case 2: return [3 /*break*/, 4];
                            case 3:
                                listFn_1 = listFn_1;
                                options = options;
                                _a.label = 4;
                            case 4:
                                if (!!this.chariot.options.cache) return [3 /*break*/, 6];
                                return [4 /*yield*/, listFn_1.call(this, options)];
                            case 5: return [2 /*return*/, _a.sent()];
                            case 6: return [4 /*yield*/, this.chariot.waitForLogin()];
                            case 7:
                                _a.sent();
                                cacheKey = (0, exports.createChariotCacheHashFromObject)(this.chariot, { options: options });
                                if (options && options.getAsAdmin) {
                                    if (this instanceof ChariotResourceFactory_1.GraphEnabledChariotResourceFactory) {
                                        graphOptions = options;
                                        cacheKey = (0, exports.createHashFromObject)({ filters: graphOptions.filters });
                                    }
                                    else {
                                        restOptions = options;
                                        cacheKey = (0, exports.createHashFromObject)({ params: restOptions.params });
                                    }
                                }
                                retrieveData = listFn_1.bind(this, options);
                                return [4 /*yield*/, memoizeMethod(cacheKey, retrieveData, "list", this.cache, this.chariot.logger)];
                            case 8: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            break;
        }
        case "iterate": {
            var iterateFn_1 = descriptor.value;
            descriptor.value = function (options) {
                return __asyncGenerator(this, arguments, function () {
                    var generator, results, _loop_1, this_1, generator_1, generator_1_1, e_1_1;
                    var _this = this;
                    var e_1, _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, __await(this.chariot.waitForLogin())];
                            case 1:
                                _b.sent();
                                generator = iterateFn_1.call(this, options), results = [];
                                _b.label = 2;
                            case 2:
                                _b.trys.push([2, 8, 9, 14]);
                                _loop_1 = function () {
                                    var item, graphOptions;
                                    return __generator(this, function (_c) {
                                        switch (_c.label) {
                                            case 0:
                                                item = generator_1_1.value;
                                                graphOptions = options;
                                                if (!(!this_1.chariot.options.cache || (options && Object.prototype.hasOwnProperty.call(options, "selectionSet")))) return [3 /*break*/, 3];
                                                return [4 /*yield*/, __await(item)];
                                            case 1: return [4 /*yield*/, _c.sent()];
                                            case 2:
                                                _c.sent();
                                                return [3 /*break*/, 10];
                                            case 3:
                                                if (!(this_1 instanceof ChariotResourceFactory_1.GraphEnabledChariotResourceFactory && (graphOptions === null || graphOptions === void 0 ? void 0 : graphOptions.selectionSet))) return [3 /*break*/, 6];
                                                return [4 /*yield*/, __await(item)];
                                            case 4: return [4 /*yield*/, _c.sent()];
                                            case 5:
                                                _c.sent();
                                                return [3 /*break*/, 10];
                                            case 6:
                                                if (!item._.id) return [3 /*break*/, 10];
                                                return [4 /*yield*/, __await(memoizeMethod(item._.id, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                                        return [2 /*return*/, item];
                                                    }); }); }, "get", this_1.cache, this_1.chariot.logger))];
                                            case 7:
                                                _c.sent();
                                                results.push(item);
                                                return [4 /*yield*/, __await(item)];
                                            case 8: return [4 /*yield*/, _c.sent()];
                                            case 9:
                                                _c.sent();
                                                _c.label = 10;
                                            case 10: return [2 /*return*/];
                                        }
                                    });
                                };
                                this_1 = this;
                                generator_1 = __asyncValues(generator);
                                _b.label = 3;
                            case 3: return [4 /*yield*/, __await(generator_1.next())];
                            case 4:
                                if (!(generator_1_1 = _b.sent(), !generator_1_1.done)) return [3 /*break*/, 7];
                                return [5 /*yield**/, _loop_1()];
                            case 5:
                                _b.sent();
                                _b.label = 6;
                            case 6: return [3 /*break*/, 3];
                            case 7: return [3 /*break*/, 14];
                            case 8:
                                e_1_1 = _b.sent();
                                e_1 = { error: e_1_1 };
                                return [3 /*break*/, 14];
                            case 9:
                                _b.trys.push([9, , 12, 13]);
                                if (!(generator_1_1 && !generator_1_1.done && (_a = generator_1.return))) return [3 /*break*/, 11];
                                return [4 /*yield*/, __await(_a.call(generator_1))];
                            case 10:
                                _b.sent();
                                _b.label = 11;
                            case 11: return [3 /*break*/, 13];
                            case 12:
                                if (e_1) throw e_1.error;
                                return [7 /*endfinally*/];
                            case 13: return [7 /*endfinally*/];
                            case 14: return [4 /*yield*/, __await(results)];
                            case 15: return [2 /*return*/, _b.sent()];
                        }
                    });
                });
            };
            break;
        }
        case "get": {
            var getFn_1 = descriptor.value;
            descriptor.value = function (id, options) {
                return __awaiter(this, void 0, void 0, function () {
                    var graphGetFn, graphOptions, retrieveData, retrieveData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(this instanceof ChariotResourceFactory_1.GraphEnabledChariotResourceFactory)) return [3 /*break*/, 5];
                                graphGetFn = getFn_1;
                                graphOptions = options;
                                if (!(!this.chariot.options.cache || (graphOptions === null || graphOptions === void 0 ? void 0 : graphOptions.selectionSet))) return [3 /*break*/, 2];
                                return [4 /*yield*/, graphGetFn.call(this, id, graphOptions)];
                            case 1: return [2 /*return*/, _a.sent()];
                            case 2: return [4 /*yield*/, this.chariot.waitForLogin()];
                            case 3:
                                _a.sent();
                                retrieveData = graphGetFn.bind(this, id, graphOptions);
                                return [4 /*yield*/, memoizeMethod(id, retrieveData, "get", this.cache, this.chariot.logger)];
                            case 4: return [2 /*return*/, _a.sent()];
                            case 5:
                                getFn_1 = getFn_1;
                                if (!!this.chariot.options.cache) return [3 /*break*/, 7];
                                return [4 /*yield*/, getFn_1.call(this, id)];
                            case 6: return [2 /*return*/, _a.sent()];
                            case 7: return [4 /*yield*/, this.chariot.waitForLogin()];
                            case 8:
                                _a.sent();
                                retrieveData = getFn_1.bind(this, id);
                                return [4 /*yield*/, memoizeMethod(id, retrieveData, "get", this.cache, this.chariot.logger)];
                            case 9: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            break;
        }
        case "find": {
            var findFn_1 = descriptor.value;
            descriptor.value = function (options) {
                return __awaiter(this, void 0, void 0, function () {
                    var graphOptions, cacheKey, retrieveData, cacheKey, retrieveData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(this instanceof ChariotResourceFactory_1.GraphEnabledChariotResourceFactory)) return [3 /*break*/, 5];
                                findFn_1 = findFn_1;
                                graphOptions = options;
                                if (!(!this.chariot.options.cache || graphOptions.selectionSet)) return [3 /*break*/, 2];
                                return [4 /*yield*/, findFn_1.call(this, graphOptions)];
                            case 1: return [2 /*return*/, _a.sent()];
                            case 2: return [4 /*yield*/, this.chariot.waitForLogin()];
                            case 3:
                                _a.sent();
                                cacheKey = (0, exports.createChariotCacheHashFromObject)(this.chariot, { options: options });
                                retrieveData = findFn_1.bind(this, graphOptions);
                                return [4 /*yield*/, memoizeMethod(cacheKey, retrieveData, "find", this.cache, this.chariot.logger)];
                            case 4: return [2 /*return*/, _a.sent()];
                            case 5:
                                findFn_1 = findFn_1;
                                options = options;
                                if (!!this.chariot.options.cache) return [3 /*break*/, 7];
                                return [4 /*yield*/, findFn_1.call(this, options)];
                            case 6: return [2 /*return*/, _a.sent()];
                            case 7: return [4 /*yield*/, this.chariot.waitForLogin()];
                            case 8:
                                _a.sent();
                                cacheKey = (0, exports.createChariotCacheHashFromObject)(this.chariot, { options: options });
                                retrieveData = findFn_1.bind(this, options);
                                return [4 /*yield*/, memoizeMethod(cacheKey, retrieveData, "find", this.cache, this.chariot.logger)];
                            case 9: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            };
            break;
        }
        default:
            throw new Errors_1.InvalidMethodError("Unable to memoize ".concat(target.constructor.name, ".").concat(methodKey));
    }
};
exports.memoizable = memoizable;
